"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpanLinkChooserState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var services_1 = require("../../services");
var store_1 = require("../../store");
var multi_list_chooser_state_1 = require("./multi.list.chooser.state");
var SpanLinkChooserState = /** @class */ (function (_super) {
    tslib_1.__extends(SpanLinkChooserState, _super);
    function SpanLinkChooserState(collection) {
        var _this = _super.call(this, (0, i18n_1.Translate)(i18n_1.T.SPAN)) || this;
        _this.collection = collection;
        return _this;
    }
    Object.defineProperty(SpanLinkChooserState.prototype, "groups", {
        get: function () {
            var spanLinkRecords = this.nearbySpans;
            if (spanLinkRecords == null) {
                return null;
            }
            if (spanLinkRecords.length === 0) {
                this.setError(i18n_1.T.SPAN_LINK_NO_MATCH);
                return [];
            }
            this.setError(null);
            var items = [];
            for (var _i = 0, spanLinkRecords_1 = spanLinkRecords; _i < spanLinkRecords_1.length; _i++) {
                var spanLinkRecord = spanLinkRecords_1[_i];
                var collection = spanLinkRecord.collection;
                var spanInstance = spanLinkRecord.instance;
                var collectionTitle = this.getCollectionTitle(collection);
                items.push({
                    key: collection.id,
                    value: "".concat(collection.schema.titleField.displayName, " = ").concat(collectionTitle, ", ").concat(spanInstance.title)
                });
            }
            return [{
                    title: (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_SELECT_CONTENT),
                    items: items,
                    selected: items.length > 0 ? items[0].key : null
                }];
        },
        enumerable: false,
        configurable: true
    });
    SpanLinkChooserState.prototype.selectDefaultValue = function () {
        var spanLinkRecords = this.nearbySpans;
        if (spanLinkRecords == null || spanLinkRecords.length === 0) {
            this.setValue(null);
        }
        else {
            this.setValue([spanLinkRecords[0].collection.id]);
        }
    };
    Object.defineProperty(SpanLinkChooserState.prototype, "nearbySpans", {
        get: function () {
            var _this = this;
            var tagSummary = store_1.AppStore.TagSummary.get(this.collection.jobId);
            if (tagSummary == null || tagSummary.revisions == null) {
                return null;
            }
            var collections = [];
            for (var _i = 0, _a = tagSummary.revisions; _i < _a.length; _i++) {
                var collectionRevision = _a[_i];
                var collection = store_1.AppStore.Collection.get(collectionRevision);
                if (collection != null) {
                    collections.push(collection);
                }
            }
            if (collections.length === 0) {
                return null;
            }
            var candidateCollections = collections.filter(function (collection) { return collection.id !== _this.collection.id; });
            return services_1.Services.SubFormLink.findLinks(this.collection, candidateCollections);
        },
        enumerable: false,
        configurable: true
    });
    SpanLinkChooserState.prototype.setValue = function (value) {
        this._value = value;
    };
    SpanLinkChooserState.prototype.getSelectedSpanLinkRecord = function () {
        var _this = this;
        if (this.value == null) {
            return null;
        }
        return this.nearbySpans.find(function (record) { return record.collection.id === _this.value[0]; });
    };
    SpanLinkChooserState.prototype.getCollectionTitle = function (collection) {
        var title = collection.title;
        return title != null ? title : (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE);
    };
    tslib_1.__decorate([
        mobx_1.action
    ], SpanLinkChooserState.prototype, "selectDefaultValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SpanLinkChooserState.prototype, "nearbySpans", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SpanLinkChooserState.prototype, "setValue", null);
    return SpanLinkChooserState;
}(multi_list_chooser_state_1.MultiChooserState));
exports.SpanLinkChooserState = SpanLinkChooserState;
//# sourceMappingURL=span.link.chooser.state.js.map